import React from 'react'
import { trackSearchResultListSearchEvent } from '@libs/eventTracking/search'
import Link from 'next/link'
import { searchUrl } from '@libs/appUrl'

interface HashTagProps {
  tag: string
  keyword: string
  articleId: string
  typeFilter?: string
  sortFilter?: string
}

export default function HashTag(props: HashTagProps) {
  const { tag, keyword, articleId, typeFilter, sortFilter } = props
  const onClick = () => {
    if (!tag || !keyword || !articleId) return
    const toPageUrl = searchUrl(tag, 1, typeFilter, sortFilter)
    trackSearchResultListSearchEvent({
      toPageUrl,
      currentKeyword: keyword,
      searchKeyword: tag,
      typeFilter,
      sortFilter,
    })
  }

  return (
    <Link href={searchUrl(`#${tag}`)}>
      <a onClick={onClick}>{`#${tag}`}</a>
    </Link>
  )
}
